import React from 'react';
import MobileService from 'services/mobile';
import styles from './index.module.scss';

interface ButtonProps {
  icon: string;
  color: 'mint' | 'orange';
  text: string;
  width?: number;
  disableCalendar?: boolean;
  onClick?: () => void;
}

const CustomButton: React.FC<ButtonProps> = ({
  icon,
  text,
  color,
  width,
  onClick,
  disableCalendar,
}) => {
  return (
    <div
      onClick={onClick}
      role="button"
      onKeyDown={onClick}
      tabIndex={0}
      className={`${styles.container} ${
        disableCalendar && styles.containerAlign
      } ${MobileService.isMobile ? styles.tablet : ''}`}
      style={width ? { width } : {}}
    >
      <div
        style={disableCalendar ? { display: 'none' } : {}}
        className={color === 'mint' ? styles.mint : styles.orange}
      >
        <img src={icon} alt={icon} />
      </div>
      <span>{text}</span>
    </div>
  );
};

export default CustomButton;
